import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AutocorrectTimeDirective } from './autocorrect-time.directive';
import { FormMandatoryStarDirective } from './form-mandatory-star.directive';
import { PhoneFormatterDirective } from './phone-formatter.directive';
import { ClickOutsideDirective } from './click-outside.directive';
import { DisplayTooltipForEllipsisDirective } from './display-tooltip-for-ellipsis.directive';

@NgModule({
	declarations: [
		AutocorrectTimeDirective,
		FormMandatoryStarDirective,
		PhoneFormatterDirective,
  	ClickOutsideDirective,
		DisplayTooltipForEllipsisDirective
	],
	imports: [
		CommonModule
	],
	exports: [
		AutocorrectTimeDirective,
		FormMandatoryStarDirective,
		PhoneFormatterDirective,
		ClickOutsideDirective,
		DisplayTooltipForEllipsisDirective
	],
})
export class SharedDirectiveModule {
}
